<template>
  <div>
    <button @click="buttonClick('kiyaku')">{{ kiyakuData.buttons.kiyaku }}</button>
    <div v-if="kiyaku" v-html="kiyakuData.kiyaku"></div>

    <button @click="buttonClick('copy')">{{ kiyakuData.buttons.copy }}</button>
    <div v-if="copy" v-html="kiyakuData.copy"></div>

    <button @click="buttonClick('shikin')">{{ kiyakuData.buttons.shikin }}</button>
    <div v-if="shikin" v-html="kiyakuData.shikin"></div>
    
    <button @click="buttonClick('tokutei')">{{ kiyakuData.buttons.tokutei }}</button>
    <div v-if="tokutei" v-html="kiyakuData.tokutei"></div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return{
      kiyaku: false,
      copy: false,
      shikin: false,
      tokutei: false,
      kiyakuData: {}
    }
  },
  created(){
    var self = this;
    axios.get(this.$store.state.APIbase + 'public/kiyakuData.json')
      .then((res) => {
        var data = res.data
        var hyouji = this.$store.state.easy;
        if(hyouji == 0){
          self.kiyakuData = data.normal;
        }else if(hyouji == 1){
          self.kiyakuData = data.easy1;
        }else if(hyouji == 2){
          self.kiyakuData = data.easy2;
        }else if(hyouji == 3){
          self.kiyakuData = data.easy3;
        }
      });
  },
  methods:{
    buttonClick: function(e){
      if( e == 'kiyaku'){
        this.kiyaku = !this.kiyaku;
        this.copy = false;
        this.shikin = false;
        this.tokutei = false;
      }else if( e == 'copy'){
        this.kiyaku = false;
        this.copy = !this.copy;
        this.shikin = false;
        this.tokutei = false;
      }else if( e == 'shikin'){
        this.kiyaku = false;
        this.copy = false;
        this.shikin = !this.shikin;
        this.tokutei = false;
      }else if( e == 'tokutei'){
        this.kiyaku = false;
        this.copy = false;
        this.shikin = false;
        this.tokutei = !this.tokutei;
      }
    },
  }
};
</script>

<style scoped>
button {
  position: relative;
  width: 100%;
  top: 10px;
  font-size: 1rem;
  transition: all .4s;
  font-size: 1.3rem;
}
button:hover{
  transform: scale(1.1);
}
button:active{
  transform: scale(1.0);
}
label{
  margin-top: 10px;
}
.buyButton{
  background: #4690CF;
  color: white;
  width: 50%;
  margin-top: -30px;
}
h6{
  text-align: left;
  font-size: 1.7rem;
}
p{
  text-align: left;
}
</style>
